import React, { Fragment } from "react";
import PropTypes from "prop-types";
import Section from "../../../common/Section";
import Form from "../../../common/Form";
import Row from "../../../common/Row";
import SelectInput from "../../../common/SelectInput";
import TextInput from "../../../common/TextInput";
import NumberInput from "../../../common/NumberInput";
import DownloadUploadFiles from "../../../common/DownloadUploadFiles";
import * as DomainConstants from "../../../../constants/DomainConstants";
import emptyGuid from "../../../../util/emptyGuid.js";
import * as types from "../../../../constants/ComponentConstants";


const FinancierEditForm = (props) => {
    const {
        model,
        color,
        financiers,
        disabled,
        onBewaarClick,
        onSluitClick,
        onChange,
        validationMessages,
        documenten,
        sjablonen,
        onDropFiles,
        onDeleteFile,
        fileSessionStarted,
        dossierId,
        totaleInvestering,
        fileTypes,
        validationMessageType
    } = props;


    function getFilesForDossierComponent(component) {
        if (documenten && documenten.length > 0) {
            const gevondenDocumenten = documenten.find(x => x.name === component);
            if (gevondenDocumenten)
                return gevondenDocumenten.files;
        }

        return [];
    }

    function getFilesForSjabloonComponent(component) {
        if (sjablonen) {
            const folder = sjablonen.find(x => x.name === component.replace(/"/g, ''));
            if (folder) return folder.files;
        }
        return [];
    }

    function mapDropFiles(component) {
        return function (files) {
            onDropFiles(component, files);
        };
    }

    function mapDeleteFile(component) {
        return function (fileName) {
            onDeleteFile(component, fileName);
        };
    }

    const showFinancierNaam = model.financierId == emptyGuid();
    let aandeelPercent = totaleInvestering === 0 ? 0 : 100 / (totaleInvestering / Number(model.aandeelInBedrag));
    aandeelPercent = isNaN(aandeelPercent) ? 100 : +aandeelPercent.toFixed(2);

    let componentName = model.id ? DomainConstants.ComponentName.Financier + '_' + model.id : null;

    return (<Section title={"Vul onderstaande gegevens in"} color={color}>
        <Form
            title="Invulformulier financier"
            name="invulformulierFinancier"
            rightButtonLabel="Bewaar"
            onRightButtonClick={onBewaarClick}
            leftButtonLabel="Sluit"
            onLeftButtonClick={onSluitClick}
            rightButtonDisabled={disabled}

        >
            <Row>
                <SelectInput
                    label="Financier"
                    name="financierId"
                    value={model.financierId}
                    size={6}
                    items={financiers}
                    validationMessage={validationMessages.financierId}
                    validationMessageType={validationMessageType}
                    onChange={onChange}
                    disabled={disabled}
                />
                {showFinancierNaam ?
                    <TextInput
                        label="Naam externe financier"
                        name="naam"
                        value={model.naam}
                        size={6}
                        validationMessage={validationMessages.naam}
                        validationMessageType={validationMessageType}
                        onChange={onChange}
                        disabled={disabled}
                        maxLength={300}
                    />
                    : null}
            </Row>
            <Row>
                <NumberInput
                    label={"Aandeel in bedrag"}
                    name={"aandeelInBedrag"}
                    onChange={onChange}
                    value={model.aandeelInBedrag}
                    size={6}
                    disabled={disabled}
                    validationMessage={validationMessages.aandeelInBedrag}
                    validationMessageType={validationMessageType}
                    isValuta
                />
                <TextInput
                    name="aandeelVlaanderenInPercent"
                    label={"Aandeel in percent"}
                    value={aandeelPercent + " %"}
                    size={6}
                    disabled
                />
            </Row>
            <Row>
                <DownloadUploadFiles
                    dossierId={dossierId}
                    title='Voorbeelddocument "Bewijs van financiering"'
                    size={6}
                    disabled={disabled}
                    tab={DomainConstants.DocumentTab.FinancieelSubtabFinanciering}
                    component={DomainConstants.ComponentName.BewijsVanFinancieringSjabloon}
                    files={getFilesForSjabloonComponent(DomainConstants.ComponentName.BewijsVanFinancieringSjabloon)}
                    color={color}
                    fileSessionStarted={fileSessionStarted}
                    tooltipIconColor={types.COLOR_WHITE}
                    tooltipWindowWidth={25} />
                    
                <DownloadUploadFiles
                    dossierId={dossierId}
                    title="Bewijs van financiering"
                    size={6}
                    disabled={disabled}
                    color={color}
                    tab={DomainConstants.DocumentTab.FinancieelSubtabFinanciering}
                    component={componentName}
                    onDelete={mapDeleteFile(componentName)}
                    onDrop={mapDropFiles(componentName)}
                    files={getFilesForDossierComponent(componentName)}
                    validationMessage={validationMessages ? validationMessages.ulBewijsVanFinanciering : ''}
                    validationMessageType={validationMessageType}
                    fileSessionStarted={fileSessionStarted}
                    fileTypes={fileTypes.Financier} />
            </Row>
        </Form>
    </Section>);
};

FinancierEditForm.defaultProps = {
    validationMessages: {},
    financiers: []
};

FinancierEditForm.propTypes = {
    color: PropTypes.string,
    disabled: PropTypes.bool,
    financiers: PropTypes.array,
    model: PropTypes.object,
    validationMessages: PropTypes.object,
    onBewaarClick: PropTypes.func.isRequired,
    onSluitClick: PropTypes.func.isRequired,
    onChange: PropTypes.func.isRequired,
    documenten: PropTypes.array,
    sjablonen: PropTypes.array,
    onDropFiles: PropTypes.func.isRequired,
    onDeleteFile: PropTypes.func.isRequired,
    fileSessionStarted: PropTypes.bool,
    topSportSjabloon: PropTypes.string,
    dossierId: PropTypes.string,
    totaleInvestering: PropTypes.number,
    fileTypes: PropTypes.object,
    validationMessageType: PropTypes.string
};

export default FinancierEditForm;